class LinkPosition {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
// スムーススクロール

// 固定ヘッダーの高さ（＋追加したい余白）


$(function(){
  if (window.matchMedia('(max-width: 767px)').matches) {

    var headerHeight = jQuery('header').outerHeight() + 50;
    // ページ内のアンカーへスクロール
    jQuery('a[href*="#"]').click(function () {
      var target = jQuery(this.hash === '' ? 'html' : this.hash);
      var position = target.offset().top - headerHeight;
      if (target.length) {
        jQuery('html, body').animate({scrollTop:position}, 500, 'swing');

        // #タグをURLに残す場合は削除
        return false;
      }
    });
    // ページ外のアンカーへスクロール
    var urlHash = location.hash;
    if(urlHash) {
      var target = jQuery(urlHash);
      var position = target.offset().top - headerHeight;
      // どこからスクロールさせるか ※一番上ならscrollTop(0)
      jQuery('body,html').stop().scrollTop(position + 1000);
      setTimeout(function(){
        jQuery('body,html').stop().animate({scrollTop:position}, 500, 'swing');
      }, 100);
    }

}})

$(function(){
	if (window.matchMedia('(min-width: 768px)').matches) {
    var headerHeight = jQuery('header').outerHeight() + 200;
    // ページ内のアンカーへスクロール
    jQuery('a[href*="#"]').click(function () {
      var target = jQuery(this.hash === '' ? 'html' : this.hash);
      var position = target.offset().top - headerHeight;
      if (target.length) {
        jQuery('html, body').animate({scrollTop:position}, 500, 'swing');

        // #タグをURLに残す場合は削除
        return false;
      }
    });
    // ページ外のアンカーへスクロール
    var urlHash = location.hash;
    if(urlHash) {
      var target = jQuery(urlHash);
      var position = target.offset().top - headerHeight;
      // どこからスクロールさせるか ※一番上ならscrollTop(0)
      jQuery('body,html').stop().scrollTop(position + 1000);
      setTimeout(function(){
        jQuery('body,html').stop().animate({scrollTop:position}, 500, 'swing');
      }, 100);
    }

}})



  }
}
